document.addEventListener("DOMContentLoaded", function() {
  
const nav = document.querySelector('.mer-navigation');

  let lastKnownScrollPosition = 0;
  let ticking = false;

  function doSomething(scrollPos) {
    if (scrollPos >= 80 && !nav.classList.contains('scrolled')) {
        nav.classList.add('scrolled');
    }
    if (scrollPos <= 80 && nav.classList.contains('scrolled')) {
        nav.classList.remove('scrolled');
    }
  }

  document.addEventListener("scroll", (event) => {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        doSomething(lastKnownScrollPosition);
        ticking = false;
      });

      ticking = true;
    }
  });

});
